import { MenuItemModel } from '../models/MenuItem';
import { MenuItem } from 'src/app/components/dropdown-menu/dropdown-menu.component';
import { CellActionHandlersService } from './cell-action-handlers.service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: "root" })
export class MenuItemModelParserService {
  constructor(private cellActionHandlersService: CellActionHandlersService) {}

  parse(menuItemModel: MenuItemModel, parametersDictionary: { [key: string]: string }): MenuItem {
    const { label } = menuItemModel;

    const actionParameters = this.parseParameters(menuItemModel.actionParameters, parametersDictionary);
    
    const action = () => {
      this.cellActionHandlersService[menuItemModel.actionType].apply(this.cellActionHandlersService, [ undefined, ...actionParameters] );
    };

    return {label, action};
  }

  private parseParameters(
    actionParameters: Array<string | number | boolean>,
    parametersDictionary: { [key: string]: string }
  ): Array<string | number | boolean> {
    return actionParameters.map((actionParam) => {
      if (typeof actionParam === "string" && actionParam.indexOf("{") !== -1) {
        const regex = /{(.*?)}/g;
        const found = actionParam.match(regex);
        let r = actionParam;
        if (found) {
          found.forEach((element) => {
            var value = parametersDictionary[element.replace("{", "").replace("}", "")];
            r = r.replace(element, value);
          });
        }
        return r;
      }
      return actionParam;
    });
  }
}
